export enum Passport {
  NotLogIn = 26370296117318,
}

/**
 * 授信状态
 */
export enum CREDIT_STATUS {
  NEW = 0,
  UNCREDIT = 1,
  SUCCESS = 12,
  FAIL = 13,
  /**
   * 授信中 - 授信额度待生效
   */
  EFFECTIVE_LIMIT = 9,
  /**
   * 其他异常亲看过
   */
  OTHERS = 2,
}
/**
 * curp申诉状态
 */
export enum RECOVER_STATUS {
  // 外投页面信息全部填完整
  SUBMI_INFO = 0,
  // 申诉中
  RECOVERING = 1,
  // idno被其他账号占用且已提交授信
  IDNO_USED = 2,
  // 申诉用户且curp失效
  CURP_INVALID = 3,
  // 申诉审核重传
  AUDIT_REUPLOAD = 4,
  // 申诉提交成功
  SUBMIT_SUCCESS = 5,
  // 申诉成功
  RECOVER_SUCCESS = 6,
}
/**
 * 结果页类型
 */
export const RESULT_PAGE_TYPE = {
  // 风控要求回端
  RISK_BACK: 'risk-back',
  // 授信10分钟未出结果
  WAIT_OVER: 'wait-over',
  // curp被占用
  CURP_OCCUPANCY: 'curp-occupancy',
  // 网络等其他原因
  OTHER_ERROR: 'other-error',
}
/**
 * 结果页埋点参数
 */
export const RESULT_PAGE_POINTS = {
  'risk-back': 'risk_back',
  'wait-over': 'timeout',
  'curp-occupancy': 'curp_occupy',
  'other-error': 'net_issue',
}

export interface Option {
  value: string
  text: string
}

export const APPLY_CHANNEL = 9

/**
 * 官网地址
 */
export const PORTAL_URL =
  'https://web.didiglobal.com/mx/prestamos/'

export enum APP_ACTION_TYPE {
  // 独立端链路
  PRESTAMOS = '6',
  // 乘客端 -》 独立端 链路
  PASSENGER_TO_PRESTAMOS = '1-6',
  // 独立端 -》 乘客端 链路
  PRESTAMOS_TO_PASSENGER = '6-1',
  // whatsapp渠道
  WHATSAPP = '01',
}

export const UNIT = 'MXN$'
/**
 * 统一kyc状态类型
 */
export const UNIFIED_KYC_STATUS = {
  /**
   * 未授信
   */
  UNCREDIT: 'UN_SUBMIT',
  /**
   * 授信中
   */
  CREDITING: 'CREDIT_PROCESSING',
  /**
   * 授信成功
   */
  CREDITED: 'CREDIT_SUCCESS',
  /**
   * 授信失败
   */
  CREDIT_FAIL: 'CREDIT_FAIL',
}
